import React from "react";
import { useTranslation } from "react-i18next";
import { noop } from "../../../../utils/noop";
import { Icon } from "../../../Icon/Icon";
import "./AdminAccessControlActions.css";

export const AdminAccessControlActions = ({
  type = "revoke",
  doAction,
  disabled = false,
}) => {
  return (
    <div className="AdminAccessControlActions">
      {type === "revoke" && (
        <RevokeDisplay doAction={doAction} disabled={disabled} />
      )}
      {type === "cancel" && (
        <CancelInviteDisplay doAction={doAction} disabled={disabled} />
      )}
    </div>
  );
};

const RevokeDisplay = ({ doAction, disabled }) => {
  const { t } = useTranslation();
  return (
    <div
      className={
        disabled ? "RevokeDisplay RevokeDisplay--disabled" : "RevokeDisplay"
      }
      onClick={disabled ? noop : doAction}
    >
      <div className="RevokeDisplay__icon">
        <Icon name="iconStop" width={16} height={16} />
      </div>
      <div className="RevokeDisplay__text">{t("users.revokeAccess")}</div>
    </div>
  );
};

const CancelInviteDisplay = ({ doAction, disabled }) => {
  const { t } = useTranslation();
  return (
    <div
      className={
        disabled
          ? "CancelInviteDisplay CancelInviteDisplay--disabled"
          : "CancelInviteDisplay"
      }
      onClick={disabled ? noop : doAction}
    >
      <div className="CancelInviteDisplay__icon">
        <Icon name="iconCross" width={12} height={12} />
      </div>
      <div className="CancelInviteDisplay__text">
        {t("generic.cancelInvite")}
      </div>
    </div>
  );
};
